export default __webpack_public_path__ + "static/media/my.09b238ce.mp4";